import { ECustomerGroup, SalesOrgDto } from '@/services/connecteur'
import serviceModule from '@/store/modules/ServiceModule'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'

@Module({ namespaced: true, name: 'salesOrgsModule', dynamic: true, store })
export class SalesOrgsModule extends VuexModule {
  private salesOrgCache: SalesOrgDto[] = []
  private salesOrgSelectedCache: SalesOrgDto = new SalesOrgDto()
  private salesOrgLoading = false;

  public get salesOrgs (): SalesOrgDto[] {
    return this.salesOrgCache ?? []
  }

  public get salesOrgsWithoutDisabled(): SalesOrgDto[] {
    return this.salesOrgCache.filter(_ => !_.isDisabled)
  }

  public get selectedSalesOrg (): SalesOrgDto {
    return this.salesOrgSelectedCache
  }

  public get isLoading (): boolean {
    return this.salesOrgLoading
  }

  @Mutation
  public updateSalesOrgList (list: SalesOrgDto[]) {
    this.salesOrgCache = list
  }

  @Mutation
  public updateSalesOrgLoading (value: boolean): void {
    this.salesOrgLoading = value
  }

  @Mutation
  public updateSalesOrg (salesOrg: SalesOrgDto) {
    const index = this.salesOrgCache.findIndex(_ => _.id === salesOrg.id)

    if (index === -1) {
      this.salesOrgCache.push(salesOrg)
    } else {
      this.salesOrgCache.splice(index, 1, salesOrg)
    }
  }

  @Mutation
  public updateSelectedSalesOrg (value: SalesOrgDto | undefined = undefined) {
    if (value) {
      this.salesOrgSelectedCache = value
    } else {
      this.salesOrgSelectedCache = new SalesOrgDto()
      this.salesOrgSelectedCache.lvlCustomer = ECustomerGroup.LOCAL_HIERARCHY_NODE
    }
  }

  @Mutation
  public deleteSalesOrgFromCache (value: SalesOrgDto) {
    const index = this.salesOrgCache.findIndex(_ => _.id === value.id)

    if (index >= 0) {
      this.salesOrgCache.splice(index, 1)
    }
  }

  @Action({ rawError: true })
  public async loadAllSalesOrg () {
    if (this.salesOrgs.length === 0 && !this.salesOrgLoading) {
      console.log('load sales org')
      this.updateSalesOrgLoading(true)
      const addedSnpMapping = await serviceModule.salesOrgApi.getMySalesOrg()
      this.updateSalesOrgList(addedSnpMapping)
      console.log('load sales org finished')
      this.updateSalesOrgLoading(false)
    }
  }

  @Action({ rawError: true })
  public async addOrUpdateSalesOrg (value: SalesOrgDto) {
    const result = await serviceModule.salesOrgApi.createOrUpdateSalesOrg(value)
    this.updateSalesOrg(result)
  }

  @Action({ rawError: true })
  public async deleteSalesOrg (value: SalesOrgDto) {
    await serviceModule.salesOrgApi.deleteSalesOrg(value.id)
    this.deleteSalesOrgFromCache(value)
  }

  @Action({ rawError: true })
  public async reactivateSalesOrg (value: SalesOrgDto) {
    value.isDisabled = false
    const result = await serviceModule.salesOrgApi.createOrUpdateSalesOrg(value)
    this.updateSalesOrg(result)
  }
}

export default getModule(SalesOrgsModule)
